import Api from "@/api"

export default class PushNotificationsHandler {
  constructor(router, store) {
    this.router = router
    this.store = store

    this.store.watch(
      () => this.store.getters["auth/isLoggedIn"],
      (isLoggedIn) => {
        if (isLoggedIn) {
          this.init()
        }
      },
      {
        immediate: true,
      }
    )
  }

  async init() {
    await this.fetch()
  }

  markRead(id) {
    const record = this.store.getters["notifications/pushNotifications"].find(
      (notification) => notification.id === id
    )
    if (record && record.attributes && record.attributes.read) {
      return
    }

    this.store.dispatch("notifications/markRead", id)
    Api.markNotificationRead(id).catch(() =>
      this.store.dispatch("notifications/markUnread", [id])
    )
  }

  markAllRead() {
    const capturedIds = this.store.getters["notifications/pushNotifications"]
      .filter((n) => !(n.attributes && n.attributes.read))
      .map((n) => n.id)
    this.store.dispatch("notifications/markAllRead")
    Api.markAllNotificationsRead().catch(() =>
      this.store.dispatch("notifications/markUnread", capturedIds)
    )
  }

  async hide(id) {
    if (id) {
      await this.store.dispatch("notifications/hidePushNotification", id)
    }
  }

  async fetch(processId = null, show = false, navigate = false) {
    Api.fetchNotifications().then(({ data }) => {
      this.store.dispatch("notifications/setPushNotifications", data.data)

      if (processId) {
        const notification = this.store.getters[
          "notifications/pushNotifications"
        ].find((x) => x.id == processId)

        if (notification) {
          this.store.dispatch("notifications/showPushNotification", processId)
          notification.show = show
          if (show) {
            setTimeout(() => this.hide(processId), 4000)
          }
          this.process(notification.attributes.payload, navigate)
        }
      }
    })
  }

  process(data, navigate = false) {
    console.debug("PushNotificationsHandler: process data", data)
    const customData = data.data

    if (!customData) {
      return
    }

    if (customData.type != "navigate") {
      return
    }

    // do not naviate automatically
    if (navigate == false) {
      return
    }

    this.setFallbackRoute()
    this.navigate(customData)
  }

  navigate(data) {
    const object_type = data.object
    const id = data.id
    const subId = data.sub_id

    switch (object_type) {
      case "order":
        this.router.push({ name: "Order", params: { id: id } })
        break
      case "special_request":
        this.router.push({ name: "SpecialRequest", params: { id: id } })
        break
      case "event_registration":
        this.router.push({
          name: "EventRegistration",
          params: { id: id, sub: subId },
        })
        break
      case "prescription":
        this.router.push({ name: "Prescription", params: { id: id } })
        break
      case "event":
        this.router.push({ name: "Event", params: { id: id } })
        break
      case "communication":
        this.router.push({ name: "Communication", params: { id: id } })
        break
      case "cart":
        this.router.push({ name: "CartList" })
        break
    }
  }

  setFallbackRoute() {
    this.store.dispatch("navbar/setFallbackRoute", {
      path: "/home",
    })
  }
}
